export default "__VITE_ASSET__OtUCJH9q__"